import React from "react";
import { Outlet } from "react-router-dom";
import { useTenantContent } from "../../Context/TenantContentContext";
import FeatureDisabled from "../../Components/Core/FeatureDisabled";
import Loader from "../../Components/Core/Loader";

const Consultation = () => {
  const { content, loading } = useTenantContent();

  if (loading || !content) return <Loader />;

  if (content && content.isConsultationPageEnabled === false) {
    return <FeatureDisabled featureName="صفحه مشاوره آنلاین" isSubscriptionExpired={content.isSubscriptionExpired} />;
  }

  return (
    <div className="container-fluid p-0">
      <Outlet />
    </div>
  );
};

export default Consultation;
